// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"48e323a4","268":"10d02766","484":"4b60c9d5","551":"588ea919","677":"b5ce1441"}[chunkId] + ".chunk.js";
};